"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelAdvertiserStatsResponse = void 0;
var ChannelAdvertiserStatsResponse;
(function (ChannelAdvertiserStatsResponse) {
    let type;
    (function (type) {
        type["HELLOFRESH"] = "hellofresh";
    })(type = ChannelAdvertiserStatsResponse.type || (ChannelAdvertiserStatsResponse.type = {}));
    let grade;
    (function (grade) {
        grade["GOOD"] = "good";
        grade["VERY_GOOD"] = "veryGood";
        grade["NEUTRAL"] = "neutral";
        grade["BAD"] = "bad";
        grade["VERY_BAD"] = "veryBad";
    })(grade = ChannelAdvertiserStatsResponse.grade || (ChannelAdvertiserStatsResponse.grade = {}));
})(ChannelAdvertiserStatsResponse = exports.ChannelAdvertiserStatsResponse || (exports.ChannelAdvertiserStatsResponse = {}));
